import React, { memo, useMemo } from "react";
import "./style.scss";
import SignUIService from "../../services/ui-services/authService";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/store/authContext";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

const GithubSignIn: React.FC = () => {
  const signUIService = useMemo(() => {
    return new SignUIService();
  }, [])

  const { t } = useTranslation();
  const { updateLoggedInUserData: setLoggedInUserData } = useAuth();
  const navigate: NavigateFunction = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      const response = await signUIService.githubLogIn();
      if (response) {
        setLoggedInUserData(response);
        navigate("/");
      }
      return response;
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  return (
    <div onClick={handleGoogleSignIn} className="github-container">
      <FontAwesomeIcon icon={faGithub} />
      {t("githubLogin")}
    </div>
  );
};

export default memo(GithubSignIn);
